import Hero from './components/Hero';
import TechnicalEvidence from './components/TechnicalEvidence';
import Segmentation from './components/Segmentation';
import ComforsetQuality from './components/ComforsetQuality';
import ConversionForm from './components/ConversionForm';
import Footer from './components/Footer';
import HomeSeo from './components/HomeSeo';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <HomeSeo />
      <Hero />
      <TechnicalEvidence />
      <Segmentation />
      <ComforsetQuality />
      <ConversionForm />
      <Footer />
    </div>
  );
};

export default HomePage;
